import { createAction } from "redux-act";

export const sidebarToggle = createAction("sidebarToggle");
export const sidebarClose = createAction("sidebarClose");

export const increaseLoading = createAction("increaseLoading");
export const decreaseLoading = createAction("decreaseLoading");



// WEBPACK FOOTER //
// ./src/app/actions.js